import { useEffect, useRef } from 'react';

export const usePrevious = function <T>(value: T) {
  const ref = useRef<T>();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  // eslint-disable-next-line react-hooks/refs -- the hook's contract is to expose the previously committed value during render
  return ref.current;
};
